module.exports = __webpack_public_path__ + "static/40-future-of-work-how-job-crafting-will-change-the-way-we-work-9a10bf2fccd2781ed188c62dea83134b.jpg";